import { OTP_CONFIG } from '@porterin/booking-flow/src/auth/domain/config/otp';
import { AuthTexts } from '@porterin/booking-flow/src/auth/view/stores/AuthStore';
import { useCallback } from 'react';

export interface ResendOtpProps {
  onResendOtp: () => void;
  resendOtpTry: number;
  resendOtpTimer: number;
}

const ResendOtp = ({
  onResendOtp,
  resendOtpTry,
  resendOtpTimer,
}: ResendOtpProps) => {
  const getResendOtpLabel = useCallback((): JSX.Element => {
    if (resendOtpTry < OTP_CONFIG.MAX_RESEND_ATTEMPTS && resendOtpTimer === 0) {
      return (
        <>
          <div className="text-text-lg text-typography-secondary font-normal">
            {AuthTexts.otpModal.resendOtp.notReceived}
          </div>
          <button
            type="button"
            onClick={onResendOtp}
            className="ml-2 text-text-lg text-[#0A57FF] font-semibold"
          >
            {AuthTexts.otpModal.resendOtp.resend}
          </button>
        </>
      );
    } else if (
      resendOtpTry < OTP_CONFIG.MAX_RESEND_ATTEMPTS &&
      resendOtpTimer !== 0
    ) {
      return (
        <>
          <div className="text-text-lg text-typography-secondary font-normal">
            {AuthTexts.otpModal.resendOtp.notReceived}
          </div>
          <button className="ml-2 font-normal text-[#707582] text-text-lg cursor-default">
            {`${AuthTexts.otpModal.resendOtp.resendIn} ${resendOtpTimer}s`}
          </button>
        </>
      );
    } else {
      return (
        <div className="text-text-lg text-typography-secondary font-normal">
          {AuthTexts.otpModal.resendOtp.tooManyAttempts}
        </div>
      );
    }
  }, [resendOtpTry, resendOtpTimer]);

  return <div className="flex justify-center">{getResendOtpLabel()}</div>;
};

export default ResendOtp;
